<div
    [class]="(currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) ? 'main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3' : ''">
    @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
        <ms-page-title />
    }

    <!-- Page Header -->
    <div class="page-title-wrapper">
        <div class="d-flex justify-content-between flex-row flex-wrap gap-3 align-items-start">
            <div>
                <!-- Search Input Group -->
                <div class="input-group position-relative">
                    <input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
                        placeholder="Search Properties" aria-label="Search Properties"
                        [ngModel]="userSessionService.propertiesFilter.searchTerm"
                        (ngModelChange)="userSessionService.propertiesFilter.searchTerm = $event"
                        (keyup.enter)="loadProperties(false)" aria-describedby="search-description">

                    @if (userSessionService.propertiesFilter.searchTerm) {
                    <button
                        class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
                        type="button" (click)="clearSearch()" aria-label="Clear search">
                        <fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
                    </button>
                    }

                    <div class="input-group-append">
                        <button class="btn btn-primary rounded-0 rounded-end" type="button"
                            (click)="loadProperties(false)" id="button-addon2">
                            Search
                        </button>
                    </div>
                </div>
                <!-- Search Input Group -->
                <div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
                    Search by title, lot number, or address
                </div>
            </div>

            <div class="d-flex gap-3">
                <ms-property-search-filter
                    [hidden]="currentPropertyListViewLocation() !== propertyListViewLocations.PropertyListPage"
                    (filterApplied)="filterApplied()"></ms-property-search-filter>

                @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
                <ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
                    (selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

                <div class="dropdown">
                    <button class="btn btn-primary dropdown-toggle" type="button" data-bs-toggle="dropdown"
                        aria-expanded="false">
                        <span>List Actions</span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li>
                            <a class="dropdown-item" (click)="onAddPropertyClicked()">
                                <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add Property
                            </a>
                        </li>
                        <li>
                            <hr class="dropdown-divider">
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [PropertyPermission.Status],
                            userPermissionOnly: false
                        }">
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="(isSelectAll === true || selectionItems().length > 0) && confirmBulkAction(PropertyBulkActions.Activate)">
                                <fa-duotone-icon icon="circle-check" class="me-2" />Reactivate
                            </a>
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [PropertyPermission.Status],
                            userPermissionOnly: false
                        }">
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="(isSelectAll === true || selectionItems().length > 0) && confirmBulkAction(PropertyBulkActions.Deactivate)">
                                <fa-duotone-icon icon="ban" class="me-2" />Deactivate
                            </a>
                        </li>
                        <li *ifHasPermission="{
                            requiredPermissions: [PropertyPermission.Delete],
                            userPermissionOnly: false
                        }">
                            <a class="dropdown-item"
                                [class.disabled]="isSelectAll === false && selectionItems().length <= 0"
                                (click)="(isSelectAll === true || selectionItems().length > 0) && confirmBulkAction(PropertyBulkActions.Delete)">
                                <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
                            </a>
                        </li>
                    </ul>
                </div>
                }
                @if (currentPropertyListViewLocation() === propertyListViewLocations.MemberProfilePage) {
                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#addPropertiesToMemberModal"
                    *ifHasPermission="{ requiredPermissions: [PropertyPermission.Update] }">
                    <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="d-none d-sm-inline" />
                    Attach Property
                </button>
                }
            </div>
        </div>
    </div>

    <div>
        <div class="d-flex flex-wrap">
            <div class="mb-0 text-start flex-grow-0 w-50" #jumpToElementMobile>
                Showing: {{propertyList().length}} of {{totalCount | number}}
                <div class="badge bg-primary ms-0 ms-sm-2"
                    [hidden]="currentPropertyListViewLocation() !== propertyListViewLocations.PropertyListPage">
                    Selected: {{selectedCount() | number}} </div>
            </div>
            <div class="flex-grow-1 text-end d-block d-sm-none">
                <button id="toggleAllMobile" type="button" class="btn btn-ms-secondary text-start"
                    [hidden]="currentPropertyListViewLocation() !== propertyListViewLocations.PropertyListPage"
                    (click)="toggleSelectAll()">
                    <fa-duotone-icon icon="square-check" secondaryOpacity="0.2" size="lg" [hidden]="!isSelectAll" />
                    <fa-duotone-icon icon="square" secondaryOpacity="0.2" size="lg" [hidden]="isSelectAll" />
                    {{ (isSelectAll) ? 'Deselect All' : 'Select All' }}
                </button>
            </div>
        </div>

        <!-- Table Start -->
        <div class="table-responsive d-none d-sm-block">
            <table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
                <thead #jumpToElement>
                    <tr>
                        <th msResponsiveTableColumn="checkbox" [priority]="1" scope="col"><input id="toggleAllSelection" name="toggleAllSelection" type="checkbox"
                                class="form-check-input fs-6" [checked]="isSelectAll" (change)="toggleSelectAll()"
                                [hidden]="currentPropertyListViewLocation() != propertyListViewLocations.PropertyListPage" />
                        </th>
                        <th msResponsiveTableColumn="address" [priority]="1" scope="col" class="sortable" (click)="toggleSortDirection('Address')">
                            Address
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="(orderBy == propertyListSortOptions.AddressASC) ? '0.9' : '0.3' "
                                [secondaryOpacity]="(orderBy == propertyListSortOptions.AddressDESC) ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="title" [priority]="2" scope="col" class="sortable" (click)="toggleSortDirection('Title')">
                            Title
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyListSortOptions.TitleASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == propertyListSortOptions.TitleDESC ? '0.9' : '0.3' " />
                        </th>
                        @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
                        <th msResponsiveTableColumn="lotNumber" [priority]="3" scope="col" class="sortable"
                            (click)="toggleSortDirection('Lot Number')">
                            Lot Number
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyListSortOptions.LotNumberASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == propertyListSortOptions.LotNumberDESC ? '0.9' : '0.3' " />
                        </th>
                        <th msResponsiveTableColumn="memberCount" [priority]="4" scope="col" class="sortable numeric-column"
                            (click)="toggleSortDirection('Member Count')">
                            Member Count
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyListSortOptions.MemberCountASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == propertyListSortOptions.MemberCountDESC ? '0.9' : '0.3' " />
                        </th>
                        }
                        <th msResponsiveTableColumn="status" [priority]="5" scope="col"
                            [class.sortable]="currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage"
                            (click)="currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage && toggleSortDirection('Status')">
                            Status
                            @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
                            <fa-duotone-icon icon="sort" class="ms-1" size="lg"
                                [primaryOpacity]="orderBy == propertyListSortOptions.StatusASC ? '0.9' : '0.3' "
                                [secondaryOpacity]="orderBy == propertyListSortOptions.StatusDESC ? '0.9' : '0.3' " />
                            }
                        </th>
                        <th msResponsiveTableColumn="actions" [priority]="1" class="fixed-header" scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Table Row Start -->
                    @for (property of displayProperties; let i= $index; track property.propertyId) {
                    <tr class="align-middle" [className]="(i % 2 === 0)? 'even' : 'odd'">
                        <td msResponsiveTableColumn="checkbox" [priority]="1">
                            <input id="toggleAllSelection" type="checkbox" #toggleAllSelection class="form-check-input"
                                [hidden]="currentPropertyListViewLocation() !== propertyListViewLocations.PropertyListPage"
                                [value]="property.propertyId"
                                [checked]="selectionItems() | itemSelection: property.propertyId: isSelectAll"
                                (click)="selectionClicked({id: property.propertyId, checked: toggleAllSelection.checked})" />
                        </td>
                        <td msResponsiveTableColumn="address" [priority]="1" class="property-address-cell">
                            <div class="fw-bold text-truncate" [class.placeholder]="isLoading"
                                [msTooltip]="property.addresses![0] | Address:AddressPipeSecondaryAddressFormat.NewLine:AddressPipeLineSeparator.Text" msTooltipOnlyIfTruncated
                                [innerHTML]="property.addresses![0] | Address:AddressPipeSecondaryAddressFormat.NewLine | SafeHtml">
                            </div>
                        </td>
                        <td msResponsiveTableColumn="title" [priority]="2" class="property-title-cell">
                            <span class="d-block text-truncate" [class.placeholder]="isLoading"
                                [msTooltip]="property.title ?? ''" msTooltipOnlyIfTruncated>{{ property.title | noValue }}</span>
                        </td>
                        @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
                        <td msResponsiveTableColumn="lotNumber" [priority]="3">
                            <span [class.placeholder]="isLoading"
                                [msTooltip]="property?.lotNumber ?? ''" msTooltipOnlyIfTruncated>{{property?.lotNumber | noValue}}</span>
                        </td>
                        <td msResponsiveTableColumn="memberCount" [priority]="4" class="numeric-column">
                            <span [class.placeholder]="isLoading">{{property?.memberCount}}</span>
                        </td>
                        }
                        <td msResponsiveTableColumn="status" [priority]="5">
                            <ms-status-badge [status]="property.status" [isLoading]="isLoading" />
                        </td>
                        <td msResponsiveTableColumn="actions" [priority]="1">
                            <div class="dropdown">
                                <button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
                                    [class.placeholder]="isLoading">
                                    Actions
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    @if (currentPropertyListViewLocation() ===
                                    propertyListViewLocations.AddPropertyToMemberModal) {
                                    <li>
                                        <a class="dropdown-item"
                                            (click)="onAddMemberToPropertyClicked(property, PropertyMemberTypes.Owner)">
                                            <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add as
                                            Owner</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item"
                                            (click)="onAddMemberToPropertyClicked(property, PropertyMemberTypes.Tenant)">
                                            <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add as
                                            Tenant</a>
                                    </li>
                                    } @else {
                                    <li>
                                        <a class="dropdown-item"
                                            [routerLink]="['/properties/profile/', property.propertyId]">
                                            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View</a>
                                    </li>
                                    @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [PropertyPermission.Update],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item"
                                            [class.disabled]="property?.status === PropertyStatuses.Deleted"
                                            (click)="property?.status !== PropertyStatuses.Deleted && onEditPropertyClicked(property)">
                                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />Edit</a>
                                    </li>
                                    @if (property?.status === PropertyStatuses.Active) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [PropertyPermission.Status],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item"
                                            (click)="confirmPropertyStatusChange(property, false)">
                                            <fa-duotone-icon icon="ban" class="me-2" />Deactivate</a>
                                    </li>
                                    }
                                    @if (property?.status === PropertyStatuses.Inactive) {
                                    <li *ifHasPermission="{
                                        requiredPermissions: [PropertyPermission.Status],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item"
                                            (click)="confirmPropertyStatusChange(property, true)">
                                            <fa-duotone-icon icon="circle-check" class="me-2" />Reactivate</a>
                                    </li>
                                    }
                                    <li *ifHasPermission="{
                                        requiredPermissions: [PropertyPermission.Delete],
                                        userPermissionOnly: false
                                    }">
                                        <a class="dropdown-item"
                                            [class.disabled]="property?.status === PropertyStatuses.Deleted"
                                            (click)="property?.status !== PropertyStatuses.Deleted && confirmPropertyDeletion(property)">
                                            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete</a>
                                    </li>
                                    }
                                    }
                                </ul>
                            </div>
                        </td>
                    </tr>
                    }
                    <!-- Table Row End -->
                </tbody>
                <tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
                    [hasNext]="hasNext" [itemCount]="displayProperties.length" (jumpToClicked)="jumpToTop($event)">
                </tfoot>
            </table>
        </div>
        <!-- Table End -->

        <div id="mobileTableCards" class="d-block d-sm-none">
            @for (property of displayProperties; let i= $index; track property.propertyId) {

            <div class="card d-flex pt-1 d-inline d-sm-none my-3">

                <div class="d-flex flex-column card-body">

                    <div class="d-flex flex-row">
                        <div class="card-left-column d-block-flex text-center">
                            <ms-mobile-card-checkbox [item]="property" [selectionPrimaryKey]="SelectionPrimaryKeys.PropertyId"
                                [isSelected]="selectionItems() | itemSelection: property.propertyId: isSelectAll"
                                (clicked)="selectionClicked($event)" [checkboxSize]="'md'" [checkboxShape]="'circle'" />
                        </div>

                        <div class="right-card-column w-100">
                            <h5 class="card-title mb-0" [class.placeholder]="isLoading">{{property.title}}</h5>

                            <div class="text-truncate" [class.placeholder]="isLoading"
                                [innerHTML]="property.addresses![0] | Address:AddressPipeSecondaryAddressFormat.NewLine | SafeHtml">
                            </div>

                            <div class="card-text" [class.placeholder]="isLoading">
                                <span class="fw-semibold">Lot Number:</span> {{property.lotNumber }}
                            </div>

                            <div class="card-text" [class.placeholder]="isLoading">
                                <span class="fw-semibold">Members:</span> {{property.memberCount }}
                            </div>

                            <div class="card-text mt-1" [class.placeholder]="isLoading">
                                <ms-status-badge [status]="property.status" [isLoading]="isLoading" />
                            </div>
                        </div>
                    </div>
                </div>

                <button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
                    [class.placeholder]="isLoading">
                    Actions
                </button>
                <ul class="dropdown-menu dropdown-menu-end w-75">
                    @if (currentPropertyListViewLocation() === propertyListViewLocations.AddPropertyToMemberModal) {
                    <li>
                        <a class="dropdown-item"
                            (click)="onAddMemberToPropertyClicked(property, PropertyMemberTypes.Owner)">
                            <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add as Owner</a>
                    </li>
                    <li>
                        <a class="dropdown-item"
                            (click)="onAddMemberToPropertyClicked(property, PropertyMemberTypes.Tenant)">
                            <fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="me-2" />Add as Tenant</a>
                    </li>
                    } @else {
                    <li>
                        <a class="dropdown-item" [routerLink]="['/properties/profile/', property.propertyId]">
                            <fa-duotone-icon icon="eye" secondaryOpacity="0.9" class="me-2" />View</a>
                    </li>
                    @if (currentPropertyListViewLocation() === propertyListViewLocations.PropertyListPage) {
                    <li *ifHasPermission="{
                        requiredPermissions: [PropertyPermission.Update],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item"
                            [class.disabled]="property?.status === PropertyStatuses.Deleted"
                            (click)="property?.status !== PropertyStatuses.Deleted && onEditPropertyClicked(property)">
                            <fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.9" class="me-2" />Edit</a>
                    </li>
                    @if (property?.status === PropertyStatuses.Active) {
                    <li *ifHasPermission="{
                        requiredPermissions: [PropertyPermission.Status],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item"
                            (click)="confirmPropertyStatusChange(property, false)">
                            <fa-duotone-icon icon="ban" class="me-2" />Deactivate</a>
                    </li>
                    }
                    @if (property?.status === PropertyStatuses.Inactive) {
                    <li *ifHasPermission="{
                        requiredPermissions: [PropertyPermission.Status],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item"
                            (click)="confirmPropertyStatusChange(property, true)">
                            <fa-duotone-icon icon="circle-check" class="me-2" />Reactivate</a>
                    </li>
                    }
                    <li *ifHasPermission="{
                        requiredPermissions: [PropertyPermission.Delete],
                        userPermissionOnly: false
                    }">
                        <a class="dropdown-item"
                            [class.disabled]="property?.status === PropertyStatuses.Deleted"
                            (click)="property?.status !== PropertyStatuses.Deleted && confirmPropertyDeletion(property)">
                            <fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete</a>
                    </li>
                    }
                    }
                </ul>
            </div>
            }
            <div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
                [hasNext]="hasNext" [itemCount]="displayProperties.length" (jumpToClicked)="jumpToTop($event)">
            </div>

        </div>

        <ms-confirmation-modal #propertyListConfirmationModalRef modalId="propertyListConfirmationModal"
            [enableNotes]="false" [isNoteRequired]="false" confirmButtonText="Yes" cancelButtonText="No"
            [(isSubmitting)]="isSubmitting"
            (confirmed)="confirmationConfirmFunction($event)" (cancelled)="confirmationCancelFunction()" />

        <ms-info-modal #propertyListInfoModalRef modalId="propertyListInfoModal" />

        <ms-property-form-modal [organization]="userSessionService.activeOrganization()"
            [property]="editingProperty()" [formState]="propertyFormState()"
            (onSuccessConfirm)="propertyFormSuccessConfirmed()"></ms-property-form-modal>
    </div>
</div>
